export enum CreditorType
{
    Foretag,
    Privatperson,
    Myndighet,
    Bank,
    Annat
}